import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import he from "he";

import Button from "../main/button";
import Input from "../main/input";
import Select from "../main/select";

import fetch from "../../utils/fetch";

import { useModalDataStore } from "../../store/modalData";
import { useClientsDataStore } from "../../store/clientsData";
import { useActiveClientIdStore } from "../../store/activeClientId";
import { useActiveClientStore } from "../../store/activeClient";
import { useStatusStore } from "../../store/statusData";
import { useSocketDataStore } from "../../store/socketData";

function useTimeAgo(_time: string | number) {
    const calc = () => {
        const given = moment(Number(_time));
        const sydneyNow = moment.tz("Australia/Sydney");
        const diffMs = sydneyNow.diff(given);
        const label = diffMs >= 0 ? "ago" : "from now";

        const totalSecs = Math.floor(Math.abs(diffMs) / 1000);
        const hours = Math.floor(totalSecs / 3600);
        const mins = Math.floor((totalSecs % 3600) / 60);
        const secs = totalSecs % 60;

        const parts = [];
        if (hours) parts.push(`${hours}h`);
        if (mins) parts.push(`${mins}m`);
        if (secs || parts.length === 0) parts.push(`${secs}s`);

        return `${parts.join(" ")} ${label}`;
    };

    const [display, setDisplay] = useState(calc);

    useEffect(() => {
        const id = setInterval(() => setDisplay(calc()), 1000);
        return () => clearInterval(id); // cleanup on unmount
    }, [_time]);

    return display;
}

interface Props {}

const Modal: React.FC<Props> = () => {
    const clients = useClientsDataStore<any>((s) => s.clients);
    const setModalData = useModalDataStore<any>((s) => s.setModalData);
    const setActiveClientId = useActiveClientIdStore<any>((s) => s.setActiveClientId);
    const setActiveClient = useActiveClientStore<any>((s) => s.setActiveClient);
    const status = useStatusStore<any>((s) => s.status);
    const setStatus = useStatusStore<any>((s) => s.setStatus);
    const bhvmTickets = useSocketDataStore<any>((s) => s.bhvmTickets);

    const TicketRow: React.FC<{ a: any; onStartCall: (a: any, parsed: any) => void }> = ({ a, onStartCall }) => {
        const timeAgo = useTimeAgo(a?.time);

        let _caller: any = {};
        try {
            _caller = a?.abd === true ? {} : a?.other?.caller || {};
        } catch {}

        const hide_cli = clients.find((b: any) => Number(b.id) === Number(a.account_id)).dids.find((b: any) => b.did === a.did).hide_cli || 0;

        return (
            <tr>
                <td>{a.client}</td>
                <td>{a.did}</td>
                <td>{hide_cli === 1 ? "CLI HIDDEN" : a.cli}</td>
                <td>
                    {a?.abd !== true && a.audio && (
                        <audio controls style={{ width: "100%", minWidth: "200px" }}>
                            <source src={a.audio} />
                        </audio>
                    )}
                </td>
                <td>
                    {moment(Number(a?.time)).tz("Australia/Sydney").format("DD-MM-YYYY HH:mm")}
                    <br />
                    {timeAgo}
                    <br />
                    <div className={(a.transcript || []).length === 0 ? "d-none" : ""} style={{ borderTop: "1px dashed grey", marginTop: "5px", paddingTop: "5px" }}>
                        {_caller?.first_name && (
                            <div>
                                <b>First name:</b> {_caller?.first_name?.value || ""}
                            </div>
                        )}
                        {_caller?.last_name && (
                            <div>
                                <b>Last name:</b> {_caller?.last_name?.value || ""}
                            </div>
                        )}
                        {_caller?.company && (
                            <div>
                                <b>Company:</b> {_caller?.company?.value || ""}
                            </div>
                        )}
                        {_caller?.callback_number && (
                            <div>
                                <b>Callback number:</b> {_caller?.callback_number?.value || ""}
                            </div>
                        )}
                        {_caller?.who_calling_for && (
                            <div>
                                <b>Who calling for:</b> {_caller?.who_calling_for?.value || ""}
                            </div>
                        )}
                        {_caller?.reason && (
                            <div>
                                <b>Reason:</b> {_caller?.reason?.value || ""}
                            </div>
                        )}
                        {_caller?.is_business && (
                            <div>
                                <b>Is business:</b> {JSON.parse(_caller?.is_business)}
                            </div>
                        )}
                    </div>
                    <div className={(a.transcript || []).length > 0 ? "d-none" : ""}>{a?.abd === true ? <span dangerouslySetInnerHTML={{ __html: `<b class="red">${a.duration}s</b> ABD CALL` }}></span> : "No Transcript"}</div>
                    <div className={(a.transcript || []).length === 0 ? "d-none" : ""} style={{ borderTop: "1px dashed grey", marginTop: "5px", paddingTop: "5px" }}>
                        {(a.transcript || []).map((b: any, ii: number) => {
                            const content = (() => {
                                try {
                                    return a._type === "ai" ? b.text : JSON.parse(b.content);
                                } catch {
                                    return null;
                                }
                            })();
                            if (!content) return null;

                            const text = a._type === "ai" ? content : content.response;
                            if (!text) return null;

                            return (
                                <div key={ii} style={{ marginBottom: "4px" }}>
                                    <b>{a._type === "ai" ? b.speaker : "Caller"}</b> {text}
                                </div>
                            );
                        })}
                    </div>
                </td>
                <td>
                    <Button
                        className={Number(hide_cli) === 1 ? "d-none" : ""}
                        small
                        color="green"
                        onClick={async () => {
                            const _is = await check_start_call(a.call_sid);
                            if (_is === true) {
                                const _did = ["+611300", "+611800", "+6113"].some((p) => a.did.startsWith(p))
                                    ? clients.find((z: any) => Number(z.id) === Number(a.account_id))?.dids.find((x: any) => Number(x.default_outbound || 0) === 1)?.did
                                    : a.did;
                                setModalData({
                                    toggle: true,
                                    type: "vca search client",
                                    start_call: {
                                        client_id: a.account_id,
                                        did: _did,
                                        cli: (_caller?.callers_phone_numnber || _caller?.callback_number?.value || a.cli).replace(/ /g, ""),
                                        sid: a.call_sid,
                                    },
                                });
                                setStatus("outbound");
                            }
                        }}
                        value={"Start call"}
                    />
                    {Number(a.assigned_to) === 0 ? <></> : <b>Assigned to you</b>}
                </td>
                <td>
                    <Button
                        small
                        color="red"
                        onClick={async () => {
                            await new fetch(`/user/vca/bhvm-start-call?call_sid=${a.call_sid}&action=close`, {}, { success: false, error: true }).get();
                        }}
                        value="Close ticket"
                    />
                </td>
            </tr>
        );
    };

    const check_start_call = async (call_sid: string) => {
        const check = await new fetch(`/user/vca/bhvm-start-call?call_sid=${call_sid}&action=assign`, {}, { success: false, error: true }).get();

        if (check.status === "success") return true;

        return false;
    };

    useEffect(() => {
        if (status === "ringing") {
            setActiveClientId(0);
            setActiveClient({});
        }
        setStatus("search");
    }, []);

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 mb-4">
                        <h5 className="text-center">BHVM Tickets</h5>
                    </div>

                    <div className="col-12 mb-4">
                        <div className="table-responsive">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <td>Client</td>
                                        <td>DID</td>
                                        <td>CLI</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(bhvmTickets || []).map((a: any, i: number) => (
                                        <TicketRow
                                            key={i}
                                            a={a}
                                            onStartCall={async (a, parsed) => {
                                                if (Number(a.assigned_to) !== 0) return;
                                                const _is = await check_start_call(a.call_sid);
                                                if (_is === true) {
                                                    setModalData({
                                                        toggle: true,
                                                        type: "vca search client",
                                                        start_call: {
                                                            client_id: a.account_id,
                                                            did: a.did,
                                                            cli: (parsed.callers_phone_number || a.cli).replace(/ /g, ""),
                                                            sid: a.call_sid,
                                                        },
                                                    });
                                                }
                                            }}
                                        />
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Modal;
